import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  uploadCompanyImages as uploadCompanyImagesThunk,
  updateCompanySettings,
  updateWatermarkSettings,
} from './service';

import {
  BACK_KEYS,
  BACK_KEYS as BK_CO_KEYS,
  BACK_WATERMARK_KEYS as BK_WM_KEYS,
  STORE_KEYS,
  WATERMARK_STORE_KEYS,
} from '@/components/CompanyConfiguration/constants';

const { WATERMARK_ENABLED } = STORE_KEYS;
const { OPACITY, SIZE, POSITION, TYPE, WATERMARK_LOGO_URL } =
  WATERMARK_STORE_KEYS;

const saveWatermarkSettingsThunk = createAsyncThunk(
  'CompanySettings/saveWatermarkSettings',
  async (watermarkSettings, { dispatch, rejectWithValue }) => {
    try {
      const {
        newLogoFile,
        watermarkLogoUrl,
        opacity,
        size,
        position,
        type,
        useCompanyLogo,
      } = watermarkSettings;

      const isNewBlob =
        typeof watermarkLogoUrl === 'string' &&
        watermarkLogoUrl.startsWith('blob:');
      const isDelete = (!watermarkLogoUrl || useCompanyLogo) && !newLogoFile;
      const shouldTouchLogo = isNewBlob || isDelete;

      const settingsPayload = {
        [BK_WM_KEYS[OPACITY]]: opacity,
        [BK_WM_KEYS[SIZE]]: size,
        [BK_WM_KEYS[POSITION]]: position,
        [BK_WM_KEYS[TYPE]]: type,
      };

      if (shouldTouchLogo) {
        const fd = new FormData();

        if (isDelete) {
          const emptyBlob = new Blob([''], {
            type: 'application/octet-stream',
          });
          fd.append(BK_CO_KEYS[WATERMARK_LOGO_URL], emptyBlob, '');
        } else {
          fd.append(BK_CO_KEYS[WATERMARK_LOGO_URL], newLogoFile);
        }

        await dispatch(
          uploadCompanyImagesThunk({
            requestBody: fd,
            imageType: BACK_KEYS[WATERMARK_LOGO_URL],
          })
        ).unwrap();

        if (isDelete && !watermarkLogoUrl) {
          await dispatch(
            updateCompanySettings({ [BK_CO_KEYS[WATERMARK_ENABLED]]: false })
          ).unwrap();
        }
      }

      await dispatch(updateWatermarkSettings(settingsPayload)).unwrap();

      return { shouldTouchLogo, isDelete };
    } catch (err) {
      return rejectWithValue(err?.message || err || 'WATERMARK_SAVE_FAILED');
    }
  }
);

export default saveWatermarkSettingsThunk;
